import axios from 'axios'

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers['Content-Type'] = 'application/json'

// $swoole
export const $swoole = axios.create({
  baseURL: import.meta.env.VITE_SWOOLE_ROOT,
})

// $ibs23
export const $ibs23 = axios.create({
  baseURL: import.meta.env.VITE_IBS23_ROOT,
})

// $uc
export const $uc = axios.create({
  baseURL: import.meta.env.VITE_UC_ROOT,
})

const extractErrorMessage = (payload) => {
  if (!payload) {
    return ''
  }

  if (typeof payload === 'string') {
    return payload
  }

  if (Array.isArray(payload.data?.error?.msg)) {
    return payload.data.error.msg.join('\n')
  }

  return payload.message || payload.msg || payload.data?.error?.msg || ''
}

$swoole.interceptors.response.use((response) => {
  const responseData = response?.data || {}
  const hasStatus = typeof responseData.status !== 'undefined'
  const hasCode = typeof responseData.code !== 'undefined'

  const statusOk = !hasStatus || responseData.status === 'success'
  const codeOk = !hasCode || responseData.code === 2000000 || responseData.code === 200000000

  if (!statusOk || !codeOk) {
    const normalizedError = new Error(extractErrorMessage(responseData) || '请求失败')

    normalizedError.code = responseData.code
    normalizedError.data = responseData.data
    normalizedError.status = response.status

    return Promise.reject(normalizedError)
  }

  return response
}, error => {
  const responseData = error?.response?.data || {}
  const message = extractErrorMessage(responseData) || error?.message || '请求失败'
  const normalizedError = new Error(message)

  normalizedError.code = responseData.code
  normalizedError.data = responseData.data
  normalizedError.status = error?.response?.status

  return Promise.reject(normalizedError)
})

$ibs23.interceptors.response.use((response) => {
  const responseData = response.data

  if (responseData.code !== 200000000) {
    const normalizedError = new Error(extractErrorMessage(responseData) || '请求失败')

    normalizedError.code = responseData.code
    normalizedError.data = responseData.data
    normalizedError.status = response.status

    return Promise.reject(normalizedError)
  }

  return response
}, error => {
  const responseData = error?.response?.data || {}
  const message = extractErrorMessage(responseData) || error?.message || '请求失败'
  const normalizedError = new Error(message)

  normalizedError.code = responseData.code
  normalizedError.data = responseData.data
  normalizedError.status = error?.response?.status

  return Promise.reject(normalizedError)
})

$uc.interceptors.response.use((response) => {
  const responseData = response?.data || {}
  const hasStatus = typeof responseData.status !== 'undefined'
  const hasCode = typeof responseData.code !== 'undefined'

  const statusOk = !hasStatus || responseData.status === 'success'
  const codeOk = !hasCode || responseData.code === 2000000 || responseData.code === 200000000

  if (!statusOk || !codeOk) {
    const normalizedError = new Error(extractErrorMessage(responseData) || '请求失败')

    normalizedError.code = responseData.code
    normalizedError.data = responseData.data
    normalizedError.status = response.status

    return Promise.reject(normalizedError)
  }

  return response
}, error => {
  const responseData = error?.response?.data || {}
  const message = extractErrorMessage(responseData) || error?.message || '请求失败'
  const normalizedError = new Error(message)

  normalizedError.code = responseData.code
  normalizedError.data = responseData.data
  normalizedError.status = error?.response?.status

  return Promise.reject(normalizedError)
})
